<template>
  <section
    v-if="obj"
    class="com-video"
    @mouseover="handleOver"
    @mouseout="handleOut"
    @click="handleRoute"
  >
    <div
      class="video-wai"
      :style="{
        height: boxHeight,
      }"
    >
      <img
        v-show="isImg"
        ref="isImg"
        :src="obj.cover_pic"
        :style="{
          height: imgHeight,
          width: '100%',
        }"
      >
      <video-player
        v-show="!isImg"
        ref="videoPlayer"
        class="video-player vjs-custom-skin com-video-player"
        :playsinline="true"
        :options="playerOptions"
        :z-index="9"
      />
    </div>
  </section>
</template>

<script>
// 引入hls.js
// import 'videojs-contrib-hls.js/src/videojs.hlsjs'
// TODO:视频 尺寸问题
export default {
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    poster: {
      type: String,
      default: ''
    },
    imgHeight: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: 'muted',
        muted: false, // 默认消除任何音频
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        // fluid: true, // 流体 按比例缩放
        loop: true, // 导致视频一结束就重新开始。
        controls: false,
        sources: [
          {
            type: 'video/mp4',
            src: ''
          }
        ],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      },
      isImg: true,
      boxHeight: '275px'
    }
  },
  computed: {},
  created() {
    this.playerOptions.sources[0].src = this.obj.video
    this.playerOptions.poster = this.poster
    this.isImg = !this.obj.video == ''
    this.$nextTick(() => {
      this.boxHeight = `${this.$refs.isImg.offsetHeight}px`
    })
  },
  methods: {
    handleOver() {
      this.isImg = false
      this.$refs.videoPlayer.player.play()
    },
    handleOut() {
      this.isImg = true
    },
    handleRoute() {
      this.$emit('path', this.obj)
    }
  }
}
</script>

<style lang="scss">
.com-video {
  button {
    left: 10000px !important;
  }
  .video-wai{
    cursor: pointer;
  }
}

</style>
